module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/empty-searchfile.641e06eb.png";